<div class="confirm">
    <!-- <img src="/assets/images/wait.svg"> -->
    <div class="animation-wrapper relative">

        <div #confirmCircleLottie></div>
    </div>
    <div class="title text-primary font-semibold font-2xl text-center max-w-17rem line-height-2">
        Please wait a moment while we confirm your account...
    </div>
</div>